(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[484],{

/***/ 90589:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/industry",
      function () {
        return __webpack_require__(82256);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30225:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ Pagina; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87165);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85957);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);





var Pagina = function(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, total = param.total, current = param.current, pageSize = param.pageSize, _onPageChange = param.onPageChange, onPageChange = _onPageChange === void 0 ? function() {} : _onPageChange;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "jsx-dde49ce82dfb9129" + " " + (classnames__WEBPACK_IMPORTED_MODULE_3___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().pagination), className) || ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__/* .Pagination */ .tl, {
                total: total,
                currentPage: current,
                pageSize: pageSize,
                prevText: "",
                nextText: "",
                onPageChange: onPageChange
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "dde49ce82dfb9129",
                children: ".semi-page{-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}.semi-page-prev,.semi-page-next{margin:0 10px!important;font-size:14px!important;width:auto!important}.semi-page-item{height:40px;width:40px;font-size:16px;color:#333;margin:0 5px}.semi-page-item:hover{background-color:#efeef6}.semi-page-item-active{color:white!important;background:#6354a2!important;border:none!important}"
            })
        ]
    });
};


/***/ }),

/***/ 82256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_pagelay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28082);
/* harmony import */ var _utils_useHead__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25838);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(51096);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _utils_useRequest__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54013);
/* harmony import */ var _components_pagination__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30225);
/* harmony import */ var _utils_useDate__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(19902);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81627);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);















var __N_SSP = true;
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var navDetail = param.navDetail;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), list = ref[0], setList = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        current: 1,
        total: 10,
        pageSize: 10
    }), page = ref1[0], setPage = ref1[1];
    var request = (0,_utils_useRequest__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_8__/* .useTranslations */ .T_)();
    console.log(router.locale);
    var getList = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(page) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, list;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            request.get("/getHomeMenuDetail", {
                                params: {
                                    page: page,
                                    path: router.asPath
                                },
                                headers: {
                                    lang: router.locale
                                }
                            })
                        ];
                    case 1:
                        ref8 = _state.sent(), list = ref8.data;
                        setList(list === null || list === void 0 ? void 0 : (ref = list.data) === null || ref === void 0 ? void 0 : (ref1 = ref.list) === null || ref1 === void 0 ? void 0 : ref1.data);
                        setPage({
                            total: list === null || list === void 0 ? void 0 : (ref2 = list.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.list) === null || ref3 === void 0 ? void 0 : ref3.total,
                            current: list === null || list === void 0 ? void 0 : (ref4 = list.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.list) === null || ref5 === void 0 ? void 0 : ref5.current_page,
                            pageSize: list === null || list === void 0 ? void 0 : (ref6 = list.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.list) === null || ref7 === void 0 ? void 0 : ref7.per_page
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(page) {
            return _ref.apply(this, arguments);
        };
    }(), [
        router.locale
    ]);
    var onPageChange = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(currentPage) {
        getList(currentPage);
        setPage((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, page), {
            current: currentPage
        }));
    // window.scrollTo(0, 0)
    }, [
        page
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        getList(1);
    }, [
        router.locale
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref;
        setPage((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, page), {
            total: navDetail === null || navDetail === void 0 ? void 0 : navDetail.list.total
        }));
        setList((navDetail === null || navDetail === void 0 ? void 0 : (ref = navDetail.list) === null || ref === void 0 ? void 0 : ref.data) || []);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagelay__WEBPACK_IMPORTED_MODULE_3__/* .PageLayout */ .X, {
        temp: "page_crumb",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "jsx-a7cc36353ef2824d" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().container) || ""),
            children: [
                (0,_utils_useHead__WEBPACK_IMPORTED_MODULE_4__/* .getHead */ .c)(navDetail),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                    className: "jsx-a7cc36353ef2824d" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().bg1) || "")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "jsx-a7cc36353ef2824d",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "jsx-a7cc36353ef2824d",
                            children: list.map(function(item) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    className: "jsx-a7cc36353ef2824d",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: item.out_link ? item.out_link : "".concat(router.locale === "en" ? "/en" : "", "/media/news_detail/").concat(item.id),
                                        target: "_blank",
                                        className: "jsx-a7cc36353ef2824d",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-a7cc36353ef2824d" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().time) || ""),
                                                children: [
                                                    (0,_utils_useDate__WEBPACK_IMPORTED_MODULE_14__/* .useDate */ .Y)(item.publish_time).day,
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        className: "jsx-a7cc36353ef2824d",
                                                        children: [
                                                            (0,_utils_useDate__WEBPACK_IMPORTED_MODULE_14__/* .useDate */ .Y)(item.publish_time).year,
                                                            ".",
                                                            (0,_utils_useDate__WEBPACK_IMPORTED_MODULE_14__/* .useDate */ .Y)(item.publish_time).month
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "jsx-a7cc36353ef2824d" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().imgBox) || ""),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    onError: function(e) {
                                                        return e.target.src = "http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg";
                                                    },
                                                    src: item.show_image,
                                                    loading: "lazy",
                                                    alt: "",
                                                    className: "jsx-a7cc36353ef2824d"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-a7cc36353ef2824d" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().info) || ""),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "jsx-a7cc36353ef2824d" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().title) || ""),
                                                        children: item.info_title
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "jsx-a7cc36353ef2824d",
                                                        children: item.brief
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-a7cc36353ef2824d" + " " + ((_index_module_scss__WEBPACK_IMPORTED_MODULE_13___default().btn) || ""),
                                                children: [
                                                    t("common.check"),
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "jsx-a7cc36353ef2824d",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                            className: "jsx-a7cc36353ef2824d"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                });
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagination__WEBPACK_IMPORTED_MODULE_6__/* .Pagina */ .I, {
                            total: page.total,
                            current: page.current,
                            pageSize: page.pageSize,
                            onPageChange: onPageChange
                        })
                    ]
                }),
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                    id: "a7cc36353ef2824d",
                    children: ""
                })
            ]
        })
    });
};


/***/ }),

/***/ 19902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useDate; }
/* harmony export */ });
var useDate = function(date) {
    var time = new Date(String(date).length === 10 ? date * 1000 : date);
    return {
        year: time.getFullYear() || "",
        month: (time.getMonth() + 1 < 10 ? "0" + (time.getMonth() + 1) : time.getMonth() + 1) || "",
        day: (time.getDate() < 10 ? "0" + time.getDate() : time.getDate()) || ""
    };
};



/***/ }),

/***/ 25838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getHead; }
/* harmony export */ });
/* unused harmony export getServerSideProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45844);





var getServerSideProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(context) {
        var ref, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _utils_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/getHomeMenuDetail", {
                            params: {
                                path: context === null || context === void 0 ? void 0 : (ref = context.resolvedUrl) === null || ref === void 0 ? void 0 : ref.split("?")[0]
                            },
                            headers: {
                                lang: (context === null || context === void 0 ? void 0 : context.locale) || "cn"
                            }
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        {
                            props: {
                                navDetail: data.data || null,
                                menuDetail: data.data || null
                            }
                        }
                    ];
            }
        });
    });
    return function getServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();
var getHead = function(menuDetail) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_title,
                    " "
                ]
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_kws) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_kws
            }),
            (menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_desc) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: menuDetail === null || menuDetail === void 0 ? void 0 : menuDetail.meta_desc
            })
        ]
    });
};



/***/ }),

/***/ 87165:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 51096:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1480":"industry_m-1480__Tjc4N","container":"industry_container__lNjA0","bg1":"industry_bg1__66MPx","btn":"industry_btn___gslW","time":"industry_time__B_AR_","imgBox":"industry_imgBox__tHVdj","info":"industry_info__BCYxP","title":"industry_title__V1DG6","left":"industry_left___mFGF"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [222,912,990,774,888,179], function() { return __webpack_exec__(90589); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);